// Add commas to long numbers
export const formatNumber = num => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

// Turn whole numbers into percentages
export const formatPercentage = value => {
  return value / 100
}

// Turn decimals into whole percentages
export const displayPercentage = value => {
  return value * 100
}

// Check to see if a rate is larger than another rate
export const compareRates = (rate1, rate2) => {
  if (parseFloat(rate2) > parseFloat(rate1)) {
    return true
  }
  return false
}

// Currency formatting
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

export const formatCurrency = value => {
  return currencyFormatter.format(value)
}

export const formatMonths = value => {
  return parseInt(value, 10)
}
